import { observer } from 'mobx-react';
import Loader from '../../../../../../Loader';
import LearningCollectionEditStore from '../../../Store';
import ChooseProductLicenseReady from './ChooseProductLicenseReady';
import { CustomizeState } from '../../../Store/Types';

interface Props {
  state: CustomizeState;
  store: LearningCollectionEditStore;
}

function ChooseProductLicenseState({ store, state }: Props) {
  switch (store.productLicensesStore.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader className="h-40" />;
    case 'error':
      return <></>;
    case 'ready':
      return (
        <ChooseProductLicenseReady
          store={store}
          state={state}
          productLicensesResource={store.productLicensesStore.state.productLicensesResource}
        />
      );
  }
}

export default observer(ChooseProductLicenseState);
